/*************************************************/
/* VIDEO                                         */
/*************************************************/

export function video() {
    const videoPlayerSelector = ".video-item__player.video-item__player--no-button";
    const customCursorUrl = "/assets/images/playCursor.svg";
    const costumCursorClass = "videoPlayerCustomCursor";
    const customCursorWidth = 110;
    const customCursorHeight = 110;
    let moveTimer = false;

    const updateCursorPosition = function (event) {
        const navigationBoxRect = event.target.closest(videoPlayerSelector).getBoundingClientRect();
        const mousePosition = {
            x: event.clientX - navigationBoxRect.left - customCursorWidth / 2,
            y: event.clientY - navigationBoxRect.top - customCursorHeight / 2
        };

        const customCursorElement = event.target.closest(videoPlayerSelector).querySelector("." + costumCursorClass);
        if (customCursorElement != null) {
            customCursorElement.style.top = mousePosition.y + "px";
            customCursorElement.style.left = mousePosition.x + "px";
        }
    };

    const init = function () {
        document.querySelectorAll(videoPlayerSelector).forEach(box => {
            box.addEventListener("mousemove", e => {
                const _event = e;
                if (_event.target.closest(videoPlayerSelector).querySelector("." + costumCursorClass) == null) {
                    const customCursor = document.createElement("img");
                    customCursor.classList.add(costumCursorClass);
                    customCursor.src = customCursorUrl;
                    customCursor.height = customCursorHeight;
                    customCursor.width = customCursorWidth;
                    customCursor.style.position = "absolute";
                    customCursor.style.zIndex = 999;
                    customCursor.style.pointerEvents = "none";
                    _event.target.closest(videoPlayerSelector).appendChild(customCursor);
                }
                moveTimer = setTimeout(() => {
                    updateCursorPosition(_event);
                }, 1);
            });

            box.addEventListener("mouseleave", (e) => {
                e.target.closest(videoPlayerSelector).querySelector("." + costumCursorClass).remove();
                moveTimer = false;
            });
        });
    };

    init();
}


// WEBPACK FOOTER //
// ./src/scripts/partials/video.js